// extracted by mini-css-extract-plugin
export default {"registrationTitle":"profile_registrationTitle_CVW2U","help":"profile_help_fONLg","logout":"profile_logout_zAo3S"};